// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/lifestyle/lifestyle.component.scss
// module id = 113
// module chunks = 0